export interface AppConfig {
  supabaseUrl: string;
  supabaseAnonKey: string;
  assistantsBackendUrl: string;
  agentsBackendUrl: string;
  mcpBackendUrl: string;
  azureClientId: string;
  azureTenantId: string;
  enableSettingsPage: boolean;
  haiUiBaseUrl: string;
  datadogRumApplicationId: string;
  datadogRumClientToken: string;
  datadogRumSite: string;
  datadogRumEnv: string;
}

function parseEnvBoolean(value: unknown, defaultValue: boolean): boolean {
  if (value == null) return defaultValue;
  if (typeof value !== 'string') return defaultValue;

  const normalized = value.trim().toLowerCase();
  if (normalized === '') return defaultValue;

  if (normalized === 'true' || normalized === '1' || normalized === 'yes' || normalized === 'on') return true;
  if (normalized === 'false' || normalized === '0' || normalized === 'no' || normalized === 'off') return false;

  return defaultValue;
}

export function getAppConfig(): AppConfig {
  const origin = typeof window !== 'undefined' ? window.location.origin : '';

  const supabaseUrl = import.meta.env.VITE_SUPABASE_URL || `${origin}/supabase`;
  const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY || '';
  // When VITE_ASSISTANTS_BACKEND_URL is set, use it directly.
  // When empty/unset, use '' so requests go to the current origin,
  // which Vite's dev proxy forwards to the backend.
  const assistantsBackendUrl = import.meta.env.VITE_ASSISTANTS_BACKEND_URL ?? '';
  const agentsBackendUrl = import.meta.env.VITE_AGENTS_BACKEND_URL ?? '';
  const rawMcpBackendUrl = import.meta.env.VITE_MCP_BACKEND_URL;
  const mcpBackendUrl =
    rawMcpBackendUrl && rawMcpBackendUrl !== 'undefined' && rawMcpBackendUrl !== 'null'
      ? rawMcpBackendUrl
      : `${origin}/mcp`;

  // Azure app registration for NAA (Nested App Authentication)
  const azureClientId = import.meta.env.VITE_AZURE_CLIENT_ID || '';
  const azureTenantId = import.meta.env.VITE_AZURE_TENANT_ID || 'common';

  const enableSettingsPage = parseEnvBoolean(import.meta.env.VITE_ENABLE_SETTINGS_PAGE, true);

  const haiUiBaseUrl = import.meta.env.VITE_HAI_UI_BASE_URL ||
  (import.meta.env.MODE === 'development' ? 'http://localhost:3006' : 'https://studio.presidio.ai');

  const datadogRumApplicationId = import.meta.env.VITE_DATADOG_RUM_APPLICATION_ID || '';
  const datadogRumClientToken = import.meta.env.VITE_DATADOG_RUM_CLIENT_TOKEN || '';
  const datadogRumSite = import.meta.env.VITE_DATADOG_RUM_SITE || 'datadoghq.com';
  const datadogRumEnv = import.meta.env.VITE_DATADOG_RUM_ENV || 'local';

  return {
    supabaseUrl,
    supabaseAnonKey,
    assistantsBackendUrl,
    agentsBackendUrl,
    mcpBackendUrl,
    azureClientId,
    azureTenantId,
    enableSettingsPage,
    haiUiBaseUrl,
    datadogRumApplicationId,
    datadogRumClientToken,
    datadogRumSite,
    datadogRumEnv,
  };
}
